import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/users/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/users', data)
  },
  get(id) {
    return http.get(`/api/v1/users/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/users/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/users/${id}/status`, null, {
      params: { status },
    });
  }
}
